export function DashboardLayout({ title, subtitle, sections, active, onSelect, children }) {
  return (
    <div className="bg-slate-100 min-h-[calc(100vh-4rem)] flex">
      {/* Sidebar desktop */}
      <aside data-testid="dashboard-sidebar" className="hidden md:flex flex-col w-64 shrink-0 bg-cc-navy text-white sticky top-16 self-start h-[calc(100vh-4rem)]">
        <div className="p-6 border-b border-white/10">
          <span className="eyebrow text-cc-gold text-[11px]">Back-office</span>
          <h1 className="font-display text-2xl mt-1 leading-tight">{title}</h1>
          {subtitle && <p className="text-white/50 text-xs mt-1 truncate">{subtitle}</p>}
        </div>
        <nav className="p-3 space-y-1 flex-1 overflow-y-auto">
          {sections.map((s) => (
            <button key={s.key} data-testid={`dash-nav-${s.key}`} onClick={() => onSelect(s.key)}
              className={`w-full flex items-center gap-3 px-4 py-3 rounded-xl text-sm font-semibold transition-colors text-left ${active === s.key ? "bg-white text-cc-navy shadow-sm" : "text-white/70 hover:bg-white/10"}`}>
              <s.icon size={18} className="shrink-0" /> <span className="truncate">{s.label}</span>
            </button>
          ))}
        </nav>
        <div className="tricolore-bar h-1.5 w-full" />
      </aside>

      <div className="flex-1 min-w-0">
        {/* Header + nav mobile */}
        <div className="md:hidden bg-cc-navy text-white px-4 pt-5 pb-4">
          <span className="eyebrow text-cc-gold text-[11px]">Back-office</span>
          <h1 className="font-display text-2xl mt-1">{title}</h1>
          <div className="flex gap-2 overflow-x-auto mt-3 pb-1 -mx-1 px-1">
            {sections.map((s) => (
              <button key={s.key} data-testid={`dash-nav-m-${s.key}`} onClick={() => onSelect(s.key)}
                className={`whitespace-nowrap inline-flex items-center gap-1.5 px-3 py-2 rounded-full text-xs font-bold transition-colors ${active === s.key ? "bg-white text-cc-navy" : "bg-white/10 text-white/70"}`}>
                <s.icon size={14} /> {s.label}
              </button>
            ))}
          </div>
        </div>
        <div className="tricolore-bar h-1.5 w-full md:hidden" />
        <div className="p-4 sm:p-6 lg:p-8">{children}</div>
      </div>
    </div>
  );
}
